import React from 'react'

import Component from './Component'
import Form from './Form/FAQsForm'
import { defaultSettings } from './defaults/settings'

const createPlugin = settings => {
    const mergedSettings = { ...defaultSettings, ...settings }

    return {
        FormComponent: props => <Form {...props} />,
        Component: props => <Component {...props} {...mergedSettings} />,

        name: 'benchmarx/content/faqs',
        version: '1.0.0',
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            faqs: [],
            selectedFaqIndex: null,
        }),
    }
}

export default createPlugin
